import { render } from "./ContentYoutubeVideo.vue?vue&type=template&id=4c473c28"
import script from "./ContentYoutubeVideo.vue?vue&type=script&lang=js"
export * from "./ContentYoutubeVideo.vue?vue&type=script&lang=js"

import "./ContentYoutubeVideo.vue?vue&type=style&index=0&id=4c473c28&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__